import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail, LOGO_LOCKUP } from "@/lib/api";

export default function ActivateAccount() {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirm) { setError("Kata sandi tidak sama."); return; }
    setBusy(true); setError("");
    try { await api.acceptInvite(token.trim(), password); navigate("/login", { replace: true }); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <div className="min-h-screen bg-[#070A12] grid-glow flex items-center justify-center p-4">
    <div className="m-card p-7 w-full max-w-md space-y-4">
      <img src={LOGO_LOCKUP} alt="MASANDI AI LABS" className="h-20 w-full object-contain" />
      <h1 className="text-2xl font-bold text-white">Aktivasi akun staf</h1>
      <p className="text-sm text-slate-400">Masukkan kode undangan dari Founder dan tentukan kata sandi sendiri.</p>
      <form onSubmit={submit} className="space-y-3">
        <input required value={token} onChange={e => setToken(e.target.value)} placeholder="Kode undangan" aria-label="Kode undangan" className="input-dark w-full p-3" />
        <input required minLength={12} type="password" autoComplete="new-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Kata sandi baru (minimal 12 karakter)" aria-label="Kata sandi baru" className="input-dark w-full p-3" />
        <input required minLength={12} type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Ulangi kata sandi" aria-label="Ulangi kata sandi" className="input-dark w-full p-3" />
        {error && <p role="alert" className="text-sm text-rose-300">{error}</p>}
        <button disabled={busy} className="btn-primary w-full p-3 disabled:opacity-50">Aktifkan akun</button>
      </form>
      <Link to="/login" className="text-sm text-blue-300">Kembali ke login</Link>
    </div>
  </div>;
}
